export default __webpack_public_path__ + "static/safe-tourism.tr-0b4a5907064099db6f2134a87d9de1da.png";